





























































































































































import DCheckbox from '~/components/atoms/DS2/DCheckbox'
import DRadio from '~/components/atoms/DS2/DRadio'
import {
  ComputedRef,
  defineComponent,
  inject,
  onMounted,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import { useSearchConditionSelect } from '~/components/logics/search/search-condition-select-cassette-hooks'
import SearchConditionSelectPrice from '~/components/organisms/DS2/SearchConditionSelectPrice'
import { ConditionOptionCommon } from '~/types/services/search'
import { Category } from '~/stub/apigateway/master/master_pb'
import { SearchServiceCondition } from '~/stub/apigateway/service/search_pb'

const searchConditionSelectCassette = defineComponent({
  name: 'SearchConditionSelectCassette',
  components: {
    DCheckbox,
    DRadio,
    SearchConditionSelectPrice
  },
  props: {
    searchCondition: {
      type: Object as PropType<ConditionOptionCommon>,
      default: () => ({})
    },
    isSingleColumn: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    isPrices: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  setup(props) {
    const { searchCondition } = toRefs(props)
    const selectedCondition = inject('selectedSearchConditionAll')
    const categoryMasterRef = inject<ComputedRef<Category.AsObject>>('categoryMasterRef')

    const {
      selectedUnitPriceMin,
      selectedUnitPriceMax,
      omittedSearchConditionItems,
      expandSearchConditionItems,
      isExpanded,
      expandTriggerLabel,
      onClickExpandTrigger,
      isShowSelectCassette,
      isShowSearchConditionItem,
      changePrice
    } = useSearchConditionSelect(
      searchCondition.value,
      selectedCondition,
      categoryMasterRef.value
    )

    onMounted(() => {
      if (selectedCondition[searchCondition.value.master.key]?.length) {
        isExpanded.value = true
      }
    })

    return {
      selectedUnitPriceMin,
      selectedUnitPriceMax,
      changePrice,
      selectedCondition,
      expandTriggerLabel,
      omittedSearchConditionItems,
      expandSearchConditionItems,
      isExpanded,
      isShowSelectCassette,
      isShowSearchConditionItem,
      onClickExpandTrigger
    }
  }
})
export default searchConditionSelectCassette
